import React, { useState, useEffect } from 'react';
import css from './Carousel.css';
import PropTypes from 'prop-types';

function CarouselLeftArrow(props) {
  return (
    <button
      className={[css.carousel_arrow]}
      onClick={props.onClick}
    >
      <span className="fa fa-2x fa-angle-left" />
    </button>
  );
}

function CarouselRightArrow(props) {
  return (
    <button
      className={[css.carousel_arrow]}
      style={{ height: props.height }}
      onClick={props.onClick}
    >
      <span className="fa fa-2x fa-angle-right" />
    </button>
  );
}

function CarouselIndicator(props) {
  return (
    <li>
      <button className={
          props.index === props.activeIndex
            ? `${css.carousel_indicator} ${css.carousel_indicator_active}`
            : `${css.carousel_indicator}`
        }
        onClick={props.onClick}
      ></button>
    </li>
  );
}

function CarouselSlide(props) {
  return (
    <li
      className={
        props.index === props.activeIndex
          ? `${css.carousel_slide} ${css.carousel_slide_active}`
          : `${css.carousel_slide}`
      }
    >
      <div className={[css.carousel_slide_content]}>{props.slide}</div>
    </li>
  );
}

function Carousel(props) {
  const [activeIndex, setActiveIndex] = useState(0);
  const [moreThanOneSlide, setMoreThanOneSlide] = useState(0);
  const [timeLeft, setTimeLeft] = useState(props.secondsToChange + 1);

  useEffect(() => {
    if (!timeLeft) {
      goToNextSlide();
      return
    }
    const intervalId = setInterval(() => {
      setTimeLeft(timeLeft - 1);
    }, 1000);
    return () => clearInterval(intervalId);
  }, [timeLeft]);

  useEffect(() => {
    setMoreThanOneSlide(props.slides.length > 1);
  });

  let goToSlide = (index) => {
    setActiveIndex(index);
  }

  let goToPrevSlide = (e) => {
    if (e) {
      e.preventDefault();
    }

    let index = activeIndex;
    let { slides } = props;
    let slidesLength = slides.length;

    if (index < 1) {
      index = slidesLength;
    }

    --index;

    setActiveIndex(index);
  }

  let goToNextSlide = (e) => {
    if (e) {
      e.preventDefault();
    }

    let index = activeIndex;
    let { slides } = props;
    let slidesLength = slides.length - 1;

    if (index === slidesLength) {
      index = -1;
    }

    ++index;

    setActiveIndex(index);
    setTimeLeft(props.secondsToChange + 1);
  }

  return (
    <div className={[css.carousel]}
      style={{ height: props.height }}>
      <div className="col-12 row sin_padding">
        <div className={`col-1 align-self-center ${moreThanOneSlide ? "" : " oculto"}`}>
          <CarouselLeftArrow onClick={e => goToPrevSlide(e)} />
        </div>
        <div className={`sin_padding ${moreThanOneSlide ? "col-10" : "col-12"}`}>
          <ul className={[css.carousel_slides]}>
            {props.slides.map((slide, index) =>
              <CarouselSlide
                key={index}
                index={index}
                activeIndex={activeIndex}
                slide={slide}
              />
            )}
          </ul>
        </div>
        <div className={`col-1 align-self-center${moreThanOneSlide ? "" : " oculto"}`}>
          <CarouselRightArrow onClick={e => goToNextSlide(e)} height={props.height} />
        </div>
      </div>

      <div className={`col-12 margin_bottom_10${moreThanOneSlide ? "" : " oculto"}`}>
        <ul className={[css.carousel_indicators]}>
          {props.slides.map((slide, index) =>
            <CarouselIndicator
              key={index}
              index={index}
              activeIndex={activeIndex}
              isActive={activeIndex === index}
              onClick={e => goToSlide(index)}
            />
          )}
        </ul>
      </div>
    </div>
  );
}

Carousel.propTypes = {
    slides: PropTypes.array.isRequired,
    height: PropTypes.string,
    secondsToChange: PropTypes.number
}
CarouselRightArrow.propTypes = {
    onClick: PropTypes.func,
    height: PropTypes.string
}
CarouselLeftArrow.propTypes = {
    onClick: PropTypes.func
}
CarouselIndicator.propTypes = {
    index: PropTypes.number.isRequired,
    activeIndex: PropTypes.number.isRequired,
    onClick: PropTypes.func
}
CarouselSlide.propTypes = {
    index: PropTypes.number.isRequired,
    activeIndex: PropTypes.number.isRequired,
}

export default Carousel;
